import { Pipe, PipeTransform } from '@angular/core';
import { IFromTo } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { IAirports } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

@Pipe({
    name: 'findAirport'
})

export class FindAirportPipe implements PipeTransform {
    public transform(code: string, airports: IAirports): IFromTo {
        const fakeAirport: IFromTo = {airport : {code}} as unknown as IFromTo;
        return airports ? airports[code] : fakeAirport;
    }
}
